import React from 'react';
import './style.scss';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
const Html = ({ options, selectedValues, handleChange, displayValue, id }) => {
  const animatedComponents = makeAnimated();

  return (
    <>
      <div className="selectDropdown">
        <Select
          defaultValue={displayValue}
          isMulti
          closeMenuOnSelect={false}
          components={animatedComponents}
          value={selectedValues || []}
          options={
            options?.map((itm) => {
              return { value: itm.id, label: itm[displayValue] };
            }) || []
          }
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={(e) => handleChange(e)}
        />
      </div>
    </>
  );
};

export default Html;
